import { Store, StoreEventType } from "react-stores";
// import {
//   Input,
//   ActionEdge,
//   NodeType,
//   GraphType,
//   SourceNodeInput,
//   NextAction,
//   HiddenInputData,
//   InputClassNames as CellClassNames,
// } from "./interfaces";
import { getFileContent, saveStringToFile } from "./utils/files";
import dummy from "./dummy";
import default_flow from "./default-flow";
import {
  MallocSdk,
  NonSpecificConstruction,
  NonSpecificConstructionFilled,
} from "@malloc-protocol/sdk";
import { P5State, dummyState } from "./components/p5-classes";
import {
  inferContextFromConstruction,
  saveContext,
  savedContextState,
} from "./components/graph-visualizer";

export interface MallocState {
  malloc?: MallocSdk;
  construction: NonSpecificConstructionFilled;
  context: P5State;

  loading?: {
    progress: number;
    max: number;
  };
}

export interface ErrorState {
  failedAction?: string;
  message?: string;
  changeToggle: boolean;
}

const initState: MallocState = {
  construction: default_flow.construction,
  context: dummyState,
};

const initErrorState: ErrorState = {
  changeToggle: false,
};

export const globalStore = new Store<MallocState>(initState);
export const errorStore = new Store<ErrorState>(initErrorState);
inferContextFromConstruction(initState, default_flow.savedContext);

export const getGlobalStore = () => globalStore.state;

// TODO: UPDATE
export const setGlobalStoreFromFile = async () => {
  const fileContents = await getFileContent();
  if (fileContents.length < 1) {
    alert("Please select a file");
    return;
  }

  const parsed = JSON.parse(await fileContents[0].text()) as fileType;

  let state = globalStore.state;
  state.construction = parsed.construction;
  inferContextFromConstruction(state, parsed.savedContext);
  globalStore.setState({ ...state });
  // console.log(parsed);

  // // TODO: use have the input be the nonspecific construction (and validated via malloc sdk) and then have a function which interpolates
  // const parsed = JSON.parse(
  //   await fileContents[0].text()
  // ) as NonSpecificConstruction;
  // const state = globalStore.state;
  // state.construction = parsed;
  // inferContextFromConstruction(state);
  // globalStore.setState({ ...state });
  // console.log(parsed);
  // // // Set the token account in to be undefined
  // // parsed.graph[SOURCE_NODE_ID].input[0][1].value = "";
  // // globalStore.setState(parsed);
};

interface fileType {
  construction: NonSpecificConstruction;
  savedContext: savedContextState;
}

export const downloadGlobalStore = async () => {
  let file: fileType = {
    construction: globalStore.state.construction,
    savedContext: saveContext(globalStore.state),
  };

  // console.log(file);

  await saveStringToFile(JSON.stringify(file), "flow.json");
};

globalStore.on(StoreEventType.Update, () =>
  console.info(new Date(), "Updated Global Store")
);
